module.exports = __webpack_public_path__ + "static/img/cont64 (4).4c61936.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont64 (4).jpg
// module id = 3LQW
// module chunks = 0